import { FC, useState } from "react"
import { useNavigate, useParams } from "react-router-dom";

import imageReset from '../../../assets/images/resetSenha.png'
import InputMask from "react-input-mask";
import './reset.css'
import api from "../../../services/api";
import Swal from "sweetalert2";
import { usePluginspace } from "../../../hooks/usePluginspace";
import { useConfig } from "../Auth";

type props = {
    close: () => void
}

const ForgotPassword: FC<props> = ({ close }) => {
    const { getToken } = usePluginspace()
    const navigate = useNavigate();
    const params = useParams();

    const [loading, setLoading] = useState(false)
    const { config } = useConfig();

    const [maskCpfjCnpj, setmaskCpfjCnpj] = useState("999.999.999-99");

    const [cpfCustomer, setCpfCustomer] = useState("");

    async function resetPassword() {

        localStorage.setItem("cpfReset", cpfCustomer);

        await api.post(`/api/customer/reset_password_code`,
            {
                cpf: cpfCustomer
            },
            {
                headers: {
                    Authorization: `Bearer ${await getToken()}`,
                },
            }).then(async (response) => {
                if (response.data.success) {
                    navigate(`/${params.pluginspace_id}/reset_password`);
                } else {
                    setLoading(false);
                    Swal.fire({
                        icon: 'error',
                        title: 'Atenção!',
                        text: 'Usuário não encontrado.',
                    })
                }
            })
            .catch((err) => {
                console.log(err)

                setLoading(false);
                Swal.fire({
                    icon: 'error',
                    title: 'Atenção!',
                    text: 'Usuário não encontrado.',
                })

            })
    }


    return (

        <div className="resetPasswordContent">

            <div className="close">
                <span onClick={() => close()}>X</span>
            </div>

            <div className="validateImage">
                <img src={imageReset} alt="Logo" />
            </div>

            <div>
                <h3>Esqueci a senha</h3>
                <span>Insira o seu CPF. Você vai receber um link via email para gerar uma nova senha</span>
            </div>


            <div className="inputs">
                <div className="headers">
                    <label>CPF</label>
                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="9" viewBox="0 0 8 9" fill="none">
                        <circle cx="4" cy="4.5" r="4" fill="#37393D" />
                    </svg>
                </div>

                <div className="cpf-Input">
                    <InputMask
                        className=''
                        mask={maskCpfjCnpj}
                        placeholder="123.456.789-00"
                        type="text"
                        value={cpfCustomer}
                        onChange={(event) => setCpfCustomer(event.target.value)}
                    />
                </div>
                <div className="buttomCadastro">
                    <button
                        style={{
                            background: config?.webappcolor.backgroundheader ? config?.webappcolor.backgroundheader : "#6E7586",
                            color: config?.webappcolor.backgroundheader ? config?.webappcolor.fontmenu : "white",
                            border: "none",
                        }}
                        onClick={() => resetPassword()}
                    >Enviar</button>
                </div>
            </div>

        </div>

    )
}

export { ForgotPassword }